import "./AboutTinyToTeen.module.css";
import Header from "@/reusable_sections/Header";
import Mission from "./sections/Mission";
import FounderNarrative from "./sections/FounderNarrative";
import Methodology from "./sections/Methodology";
import Footer from "@/reusable_sections/Footer";
export default function AboutTinyToTeenPage() {
  return <div>
      <Header />
      <Mission />
      <FounderNarrative />
      <Methodology />
      <Footer />
    </div>;
}